/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Open_AppInputs */

const en_mk_nav_open_app = /** @type {(inputs: Mk_Nav_Open_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open app`)
};

const id_mk_nav_open_app = /** @type {(inputs: Mk_Nav_Open_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka aplikasi`)
};

/**
* | output |
* | --- |
* | "Open app" |
*
* @param {Mk_Nav_Open_AppInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_open_app = /** @type {((inputs?: Mk_Nav_Open_AppInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Open_AppInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_open_app(inputs)
	return en_mk_nav_open_app(inputs)
});